import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import NodoCircuito from './NodoCircuito';
import { numeroComprobante, texto } from '../textosComprobante';
import { resumenEnlace, verboEnlace } from './armarCircuito';
import colores from '../Bandeja/coloresBandeja';

const useStyles = makeStyles((theme) => ({
  etapas: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: 'minmax(220px, 1fr)',
    gap: '16px',
    overflowX: 'auto',
    paddingBottom: '6px',
    // En celular las etapas van una debajo de la otra
    [theme.breakpoints.down('xs')]: {
      gridAutoFlow: 'row',
      gridAutoColumns: 'auto',
      gridTemplateColumns: 'minmax(0, 1fr)'
    }
  },
  etapa: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    minWidth: 0
  },
  titulo: {
    fontSize: '11px',
    fontWeight: 'bold',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: colores.secundario,
    borderBottom: `2px solid ${colores.borde}`,
    paddingBottom: '4px'
  },
  desde: {
    fontSize: '11px',
    color: colores.tenue,
    marginBottom: '2px'
  }
}));

/** Nombres de los tipos de comprobante de la etapa ("Remito", "Factura A Electronica"). */
const tituloEtapa = (nodos) => [...new Set(nodos.map((nodo) => texto(nodo.nombreComprobante) || texto(nodo.idComproba)))].join(' / ');

/** Una columna por nivel del circuito (pedido, remitos, facturas...), con de qué comprobante descarga cada uno. */
const CircuitoEtapas = ({ circuito }) => {
  const classes = useStyles();

  return (
    <div className={classes.etapas}>
      {circuito.niveles.map((nodos, nivel) => (
        <div key={nivel} className={classes.etapa}>
          <div className={classes.titulo}>{tituloEtapa(nodos)}</div>
          {nodos.map((nodo) => {
            const origenes = circuito.origenes(nodo.clave);
            return (
              <div key={nodo.clave}>
                {origenes.length > 0 && (
                  <div className={classes.desde}>
                    ← {origenes
                      .map((origen) => `${verboEnlace(origen.enlace)} ${numeroComprobante(origen.nodo)}${nodo.esRecibo ? ` (${resumenEnlace(origen.enlace)})` : ''}`)
                      .join(', ')}
                  </div>
                )}
                <NodoCircuito nodo={nodo} esRaiz={nivel === 0} circuito={circuito} />
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default CircuitoEtapas;
